import ApiService from "@/services/ApiService"

export default {

    setCredentials({ commit }, { name, type }) {

        return new Promise((resolve, reject) => {
            try {
                commit('setUserStorage', {
                    name, 
                    type
                }, {
                    root: true,
                })
                commit('setUserData', {
                    name,
                    type
                }, {
                    root: true,
                })
                commit('discover/adjustSlides', {
                    userName: name,
                    userType: type
                })
                commit('discover/setRandomStories')

                resolve()
            }
            catch(e) {
                /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
                console.error('Stories failed', e)
                reject()
            }
        })
    },

    initialLoad({ commit }) {

        ApiService.getMenusItems().then(response => {
            commit('setMenuItems', response.data)
        })

        return new Promise((resolve/*, reject */) => {
            commit( 'recruit/setFlatStories' )
            commit( 'discover/setGroupedStories' )

            if ( localStorage ) {
                const name = localStorage.getItem('userName') || ''
                const type = localStorage.getItem('userType') || 'student'

                commit('setUserData', {
                    name,
                    type
                }, {
                    root: true,
                })
                commit('discover/adjustSlides', {
                    userName: name,
                    userType: type
                })
                commit('discover/setRandomStories')
            }
            resolve()
        })
    },

}
